import { ColorsEnum } from "./colors";

const ALPHA_HAIRLINE = "1F";
const ALPHA_SHADOW = "0F";
const ALPHA_HEADER = "08";

export const SURFACE_RADIUS_CSS = "14px";
export const SURFACE_HAIRLINE_COLOR = `${ColorsEnum.maastrichtBlue}${ALPHA_HAIRLINE}`;
export const SURFACE_BORDER = `1px solid ${SURFACE_HAIRLINE_COLOR}`;
export const SURFACE_SHADOW = `0 1px 3px ${ColorsEnum.maastrichtBlue}${ALPHA_SHADOW}`;
export const SURFACE_HEADER_BACKGROUND = `${ColorsEnum.maastrichtBlue}${ALPHA_HEADER}`;
